export const environment = {
  production: false,
  // API_ENDPOINT: 'http://192.168.0.62:3000/',
  // API_ENDPOINT: 'http://localhost:3000/',
  API_ENDPOINT: 'https://api.aliascall.com/',
  APP_NAME: 'ALIAS',
  AWS_S3_MEDIA_TEMP_URL: 'https://s3.ap-northeast-2.amazonaws.com/temp.aliascall.com/',
  AWS_S3_MEDIA_URL: 'https://s3.ap-northeast-2.amazonaws.com/media.aliascall.com/'
};
